import { render, staticRenderFns } from "./CommunitySearch.vue?vue&type=template&id=d1efa128&scoped=true"
import script from "./CommunitySearch.vue?vue&type=script&lang=js"
export * from "./CommunitySearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1efa128",
  null
  
)

export default component.exports